<template>
  <div
    v-show="
      isFoodItemSelected ||
        cropInfoShow ||
        ifPDWindowShow ||
        ifPDWindowShow_ear ||
        cropInfo.ifCropShow ||
        SectInfo.ifSectShow ||
        SectSubInfo.ifSectSubShow
    "
  >
    <b-container class="informationBoxClass">
      <b-row class="informationBoxTitle" align-h="between">
        <b-col cols="9">
          <h3 class="mb-0">嘉義圖台資訊</h3>
        </b-col>
        <b-col cols="auto" class="pointer">
          <b-button class="close-button">
            <b-icon
              icon="x"
              scale="1.2"
              style="color: black; margin-top: 1rem"
              @click="closeall()"
            ></b-icon>
          </b-button>
        </b-col>
      </b-row>
      <div class="informationBoxContent">
        <b-row v-if="isFoodItemSelected">
          <b-col>
            <b-card
              tag="article"
              class="card-box mb-2"
              style="background: #eee;"
            >
              <b-collapse v-model="visible.infoshow" id="collapse-info">
                <b-card-text>
                  <!-- <DragInformationBox 
                                        :selected="infoselected"
                                        :isFoodItemSelected="isFoodItemSelected"
                                        :yearList="yearList"
                                        :yearPeroidList="yearPeroidList"
                                        :AREA_P="AREA_P"
                                        :warningTownName="warningTownName"
                                        :warningValueList="warningValueList"
                                        :historyLists="historyLists"
                                        :gisobject="gisobject"
                                    /> -->
                  <!-- <div @mousedown="onSelectElement($event)" @touchstart="onSelectElement($event)"> -->
                  <div class="p-3">
                    <b-col align-h="between">
                      <b-row>
                        <h6 class="mb-0">{{ selected.C_NAME }}</h6>
                      </b-row>
                      <b-row>
                        <!-- <b-form inline>
                                                <b-form-select v-model="yearSelected" :options="yearList" size="sm" @change="getCityArea"></b-form-select>
                                                <b-form-select v-model="periodSelected" :options="yearPeroidList[yearSelected]" size="sm" @change="getCityArea"></b-form-select>
                                            </b-form> -->
                      </b-row>
                      <!-- <b-row md="auto">
                        {{ yearSelected }}年 {{ periodSelected }}
                      </b-row> -->
                      <b-row md="auto">
                        {{ title }} | {{ checkMomth(selected.Note) }} |
                        {{ selected.PERIOD }}
                      </b-row>
                      <b-row md="auto"> 告警時間: {{ mergetime }} </b-row>
                      <b-row md="auto"> 告警門檻: {{ message }} </b-row>
                    </b-col>
                  </div>
                  <div class="p-3">
                    <b-tabs pills content-class="mt-3">
                      <b-tab title="預警資訊" active
                        ><p></p>
                        <b-col align-h="between">
                          <b-row cols="4">
                            <h6 class="mb-0 text-green font-weight-bold">
                              可能影響
                            </h6>
                          </b-row>
                          <b-row cols="3">
                            {{ this.selected.EFFECT }}
                          </b-row>
                          <b-row>
                            <h6 class="mb-0 text-green font-weight-bold">
                              防範建議
                            </h6>
                          </b-row>
                          <b-row>
                            {{ this.selected.PREVENTION }}
                          </b-row>
                          <b-row>
                            <h6 class="mb-0 text-green font-weight-bold">
                              復耕建議
                            </h6>
                          </b-row>
                          <b-row>
                            {{ this.selected.RECOVERY }}
                          </b-row>
                          <br />
                          <b-row md="auto">
                            {{ yearSelected }}年 {{ periodSelected }}
                          </b-row>
                          <b-row v-if="warningTownName != '' && showdetail">
                            {{ warningTownName }} 種植面積
                            {{ AREA_P || 0 }} 公頃
                          </b-row>
                        </b-col>
                      </b-tab>
                      <b-tab
                        title="詳細資料"
                        v-if="
                          warningValueList.ANA_TOWN_ID && selected.Note != '1'
                        "
                      >
                        偵測資訊
                        <b-table-simple hover small striped responsive>
                          <b-thead head-variant="dark">
                            <b-tr v-if="selected.Note == '2'">
                              <b-th>溫度</b-th>
                              <b-th>濕度</b-th>
                            </b-tr>
                            <b-tr
                              v-if="
                                selected.Note == '3' ||
                                  selected.Note == '4' ||
                                  selected.Note == '5'
                              "
                            >
                              <b-th>偵測時間</b-th>
                              <b-th>偵測值</b-th>
                            </b-tr>
                            <b-tr v-if="selected.Note == '6'">
                              <b-th>預測時間</b-th>
                              <b-th>天氣描述</b-th>
                              <b-th>降雨機率</b-th>
                            </b-tr>
                            <b-tr
                              v-if="
                                selected.Note == '7' ||
                                  selected.Note == '8' ||
                                  selected.Note == '9' ||
                                  selected.Note == '10'
                              "
                            >
                              <b-th>預測時間</b-th>
                              <b-th>氣溫</b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr v-if="selected.Note == '2'">
                              <b-td
                                >{{
                                  Math.round(warningValueList.TEMP * 10) / 10
                                }}
                                ℃</b-td
                              >
                              <b-td
                                >{{
                                  Math.round(warningValueList.HUMD * 10) / 10
                                }}
                                %</b-td
                              >
                            </b-tr>
                            <b-tr
                              v-if="
                                selected.Note == '3' ||
                                  selected.Note == '4' ||
                                  selected.Note == '5'
                              "
                            >
                              <b-td>{{
                                timeFormatParse(warningValueList.CREATETIME[0])
                              }}</b-td>
                              <b-td
                                >{{
                                  Math.round(
                                    warningValueList.REAL_VALUE[0] * 10
                                  ) / 10
                                }}
                                {{ selected.Note == "3" ? "mm" : "℃" }}</b-td
                              >
                            </b-tr>
                            <template v-if="selected.Note == '6'">
                              <b-tr
                                v-for="(item, index) in warningValueList.List"
                                :key="index"
                              >
                                <template v-if="item.rain != 0">
                                  <b-td>{{
                                    timeFormatParse(item.startTime)
                                  }}</b-td>
                                  <b-td>{{ item.description }}</b-td>
                                  <b-td
                                    >{{
                                      item.rain == 0 ? "-" : item.rain
                                    }}
                                    %</b-td
                                  >
                                </template>
                              </b-tr>
                            </template>
                            <template
                              v-if="
                                selected.Note == '7' ||
                                  selected.Note == '8' ||
                                  selected.Note == '9' ||
                                  selected.Note == '10'
                              "
                            >
                              <b-tr
                                v-for="(item, index) in warningValueList.List"
                                :key="index"
                              >
                                <b-td>{{
                                  timeFormatParse(item.startTime)
                                }}</b-td>
                                <b-td
                                  >{{
                                    Math.round(item.value * 10) / 10
                                  }}
                                  ℃</b-td
                                >
                              </b-tr>
                            </template>
                          </b-tbody>
                        </b-table-simple>
                        <div
                          v-if="
                            (selected.Note == '3' ||
                              selected.Note == '4' ||
                              selected.Note == '5') &&
                              historyLists.length > 0
                          "
                        >
                          三個月歷史告警
                          <b-table-simple hover small striped responsive>
                            <b-thead head-variant="dark">
                              <b-tr>
                                <b-th>告警時間</b-th>
                                <b-th>偵測值</b-th>
                              </b-tr>
                            </b-thead>
                            <b-tbody>
                              <b-tr
                                v-for="(item, index) in historyLists"
                                :key="index"
                              >
                                <b-td>{{
                                  timeFormatParse(item.CREATETIME)
                                }}</b-td>
                                <b-td
                                  >{{ Math.round(item.REAL_VALUE * 10) / 10 }}
                                  {{ selected.Note == "3" ? "mm" : "℃" }}</b-td
                                >
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </b-card-text>
              </b-collapse>
              <template #header>
                <b-row align-h="between">
                  <b-col cols="6">
                    <h6>農作物氣象預警</h6>
                  </b-col>
                  <b-col cols="auto" class="pointer">
                    <b-button
                      style="margin-right:1rem"
                      class="close-button"
                      @click="visible.infoshow = !visible.infoshow"
                    >
                      <b-icon
                        v-if="visible.infoshow"
                        icon="arrows-angle-contract"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                      <b-icon
                        v-else
                        icon="arrows-angle-expand"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                    </b-button>
                    <b-button class="close-button" @click="closeWindow">
                      <b-icon
                        icon="x"
                        scale="1.2"
                        style="color: black;"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-show="cropInfoShow && this.geoselect.length != 0">
          <b-col>
            <b-card
              tag="article"
              class="card-box mb-2"
              style="background: #eee;"
            >
              <b-collapse v-model="visible.chartshow" id="collapse-chart">
                <b-card-text>
                  <DragCropInfoChart
                    :returnthis="returnChartobj"
                    :gisobject="gisobject"
                    :cropArea="cropArea"
                    :geoselect="geoselect"
                    :cropInfoShow="cropInfoShow"
                    :geotabs="geotabs"
                  />
                </b-card-text>
              </b-collapse>
              <template #header>
                <b-row align-h="between">
                  <b-col cols="6">
                    <h6>農情作物查詢</h6><!--全國農情-->
                  </b-col>
                  <b-col cols="auto" class="pointer">
                    <b-button
                      style="margin-right:1rem"
                      class="close-button"
                      @click="visible.chartshow = !visible.chartshow"
                    >
                      <b-icon
                        v-if="visible.chartshow"
                        icon="arrows-angle-contract"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                      <b-icon
                        v-else
                        icon="arrows-angle-expand"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                    </b-button>
                    <b-button class="close-button" @click="closeChartWindow">
                      <b-icon
                        icon="x"
                        scale="1.2"
                        style="color: black;"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-show="cropInfo.ifCropShow">
          <b-col>
            <b-card
              tag="article"
              class="card-box mb-2"
              style="background: #eee;"
            >
              <b-collapse v-model="visible.cropshow" id="collapse-chart">
                <b-card-text>
                  <DragCropInformationBox
                    :cropInfo="cropInfo"
                  ></DragCropInformationBox>
                </b-card-text>
              </b-collapse>
              <template #header>
                <b-row align-h="between">
                  <b-col cols="6">
                    <h6>農情作物查詢</h6> <!--嘉義農情-->
                  </b-col>
                  <b-col cols="auto" class="pointer">
                    <b-button
                      style="margin-right:1rem"
                      class="close-button"
                      @click="visible.cropshow = !visible.cropshow"
                    >
                      <b-icon
                        v-if="visible.cropshow"
                        icon="arrows-angle-contract"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                      <b-icon
                        v-else
                        icon="arrows-angle-expand"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                    </b-button>
                    <b-button class="close-button" @click="closeCropWindow">
                      <b-icon
                        icon="x"
                        scale="1.2"
                        style="color: black;"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-show="SectInfo.ifSectShow">
          <b-col>
            <b-card
              tag="article"
              class="card-box mb-2"
              style="background: #eee;"
            >
              <b-collapse v-model="visible.sectshow" id="collapse-chart">
                <b-card-text>
                  <DragSectInformationBox
                    :SectInfo="SectInfo"
                  ></DragSectInformationBox>
                </b-card-text>
              </b-collapse>
              <template #header>
                <b-row align-h="between">
                  <b-col cols="6">
                    <h6>農情圖資大區區塊</h6>
                  </b-col>
                  <b-col cols="auto" class="pointer">
                    <b-button
                      style="margin-right:1rem"
                      class="close-button"
                      @click="visible.sectshow = !visible.sectshow"
                    >
                      <b-icon
                        v-if="visible.sectshow"
                        icon="arrows-angle-contract"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                      <b-icon
                        v-else
                        icon="arrows-angle-expand"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                    </b-button>
                    <b-button class="close-button" @click="closeSectWindow">
                      <b-icon
                        icon="x"
                        scale="1.2"
                        style="color: black;"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-show="SectSubInfo.ifSectSubShow">
          <b-col>
            <b-card
              tag="article"
              class="card-box mb-2"
              style="background: #eee;"
            >
              <b-collapse v-model="visible.sectsubshow" id="collapse-chart-1">
                <b-card-text>
                  <DragSectSubInformationBox
                    :SectSubInfo="SectSubInfo"
                  ></DragSectSubInformationBox>
                </b-card-text>
              </b-collapse>
              <template #header>
                <b-row align-h="between">
                  <b-col cols="6">
                    <h6>農情圖資小區區塊</h6>
                  </b-col>
                  <b-col cols="auto" class="pointer">
                    <b-button
                      style="margin-right:1rem"
                      class="close-button"
                      @click="visible.sectsubshow = !visible.sectsubshow"
                    >
                      <b-icon
                        v-if="visible.sectsubshow"
                        icon="arrows-angle-contract"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                      <b-icon
                        v-else
                        icon="arrows-angle-expand"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                    </b-button>
                    <b-button class="close-button" @click="closeSectSubWindow">
                      <b-icon
                        icon="x"
                        scale="1.2"
                        style="color: black;"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="ifPDWindowShow ">
          <b-col>
            <b-card
              tag="article"
              class="card-box mb-2"
              style="background: #eee;"
            >
              <b-collapse v-model="visible.diseaseshow" id="collapse-disease">
                <b-card-text>
                  <DragPDInformationBox2
                    :ifPDWindowShow="ifPDWindowShow"
                    :PDobject="PDobject"
                  />
                </b-card-text>
              </b-collapse>
              <template #header>
                <b-row align-h="between">
                  <b-col cols="6">
                    <h6>病蟲害預警</h6>
                  </b-col>
                  <b-col cols="auto" class="pointer">
                    <b-button
                      style="margin-right:1rem"
                      class="close-button"
                      @click="visible.diseaseshow = !visible.diseaseshow"
                    >
                      <b-icon
                        v-if="visible.diseaseshow"
                        icon="arrows-angle-contract"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                      <b-icon
                        v-else
                        icon="arrows-angle-expand"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                    </b-button>
                    <b-button class="close-button" @click="closePDWindow">
                      <b-icon
                        icon="x"
                        scale="1.2"
                        style="color: black;"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="ifPDWindowShow_ear">
          <b-col>
            <b-card
              tag="article"
              class="card-box mb-2"
              style="background: #eee;"
            >
              <b-collapse v-model="visible.diseaseshow" id="collapse-disease">
                <b-card-text>
                  <DragPDInformationBox3
                    :ifPDWindowShow_ear="ifPDWindowShow_ear"
                    :PDobject="PDobject" 
                  />
                </b-card-text>
              </b-collapse>
              <template #header>
                <b-row align-h="between">
                  <b-col cols="6">
                    <h6>病蟲害預警</h6>
                  </b-col>
                  <b-col cols="auto" class="pointer">
                    <b-button
                      style="margin-right:1rem"
                      class="close-button"
                      @click="visible.diseaseshow = !visible.diseaseshow"
                    >
                      <b-icon
                        v-if="visible.diseaseshow"
                        icon="arrows-angle-contract"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                      <b-icon
                        v-else
                        icon="arrows-angle-expand"
                        scale=".8"
                        style="margin-right: 1rem; color: black;"
                      ></b-icon>
                    </b-button>
                    <b-button class="close-button" @click="closePDWindow">
                      <b-icon
                        icon="x"
                        scale="1.2"
                        style="color: black;"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
// import DragInformationBox from "@/views/DragInformationBox.vue";
import DragCropInfoChart from "@/views/DragCropInfoChart.vue";
// import DragPDInformationBox2 from "@/views/DragPDInformationBox2.vue"
import DragPDInformationBox2 from "@/views/DragPDInformationBox2.vue";
import DragCropInformationBox from "@/views/DragCropInformationBox.vue";
import DragSectInformationBox from "@/views/DragSectInformationBox.vue"
import DragSectSubInformationBox from "@/views/DragSectSubInformationBox.vue"
import DragPDInformationBox3 from "@/views/DragPDInformationBox3.vue"

export default {
  name: "CropInformationBox",
  data() {
    return {
      // <summary>
      //  變數宣告
      // </summary>
      visible: {
        infoshow: false,
        chartshow: false,
        diseaseshow: false,
        cropshow: false,
        sectshow: false,
        sectsubshow: false,
      },
      datetime: [],
      mergetime: "",
      codition: "",
      showdetail: true,
      alertinformation: "",
      title: "",
      message: "",
      disasterTile: [
        "",
        "颱風警戒",
        "焚風警戒",
        "降水警戒",
        "高溫警戒",
        "寒害警戒",
        "注意霪雨",
        "注意高溫",
        "注意寒害",
        "注意回溫",
        "注意降溫",
      ],
      yearSelected: "",
      periodSelected: "",
      infoselected: Object,
      selected: Object,
    };
  },
  props: [
    "infoheight",
    "foodselected",
    "cropInfo",
    "SectInfo",
    "SectSubInfo",
    "cropInfoShow",
    "isFoodItemSelected",
    "yearList",
    "yearPeroidList",
    "AREA_P",
    "warningTownName",
    "warningValueList",
    "historyLists",
    "returnChartobj",
    "gisobject",
    "cropArea",
    "ifPDWindowShow",
    "ifPDWindowShow_ear",
    "PDobject",
    "geoselect",
    "geotabs",
  ],
  // props: ['selected','isFoodItemSelected','yearList', 'yearPeroidList', 'AREA_P', 'warningTownName', 'warningValueList', 'historyLists'],
  components: {
    // DragInformationBox,
    DragCropInfoChart,
    DragPDInformationBox2,
    DragPDInformationBox3,
    DragCropInformationBox,
    DragSectInformationBox,
    DragSectSubInformationBox,
  },
  watch: {
    selected(newVal) {
      if (newVal.CREATETIME) this.dateFormatParse(newVal.CREATETIME);
      if (newVal.DISASTER) this.changeTitle(newVal.Note);
      if (newVal) this.changeCodition(newVal);
      if (newVal.A_YEAR) this.yearSelected = newVal.A_YEAR;
      if (newVal.A_PERIOD) this.periodSelected = newVal.A_PERIOD;
    },
    "gisobject.foodseleted"(val) {
      this.selected = val;
    },
    isFoodItemSelected(val) {
      if (val) {
        this.visible.infoshow = false;
      }
    },
    cropInfoShow(val) {
      if (val) {
        this.visible.chartshow = false;
      }
    },
    //病蟲害圖資切換時要不要縮小視窗
    // ifPDWindowShow(val) {
    //   if (val) {
    //     this.visible.diseaseshow = false;
    //   }
    // },
    // ifPDWindowShow_ear(val) {
    //   if (val) {
    //     this.visible.diseaseshow = false;
    //   }
    // },
  },
  /*
    updated(){
        if(this.selected.CREATETIME) this.dateFormatParse(this.selected.CREATETIME)
        if(this.selected.DISASTER) this.changeTitle(this.selected.Note)
        if(this.selected) this.changeCodition(this.selected)
        if(this.selected.A_YEAR) this.yearSelected = this.selected.A_YEAR
        if(this.selected.A_PERIOD) this.periodSelected = this.selected.A_PERIOD
    },
    */
  mounted() {
    // this.checkPermission()
    // this.checkMomth();
  },
  methods: {
    /*       <summary>
        時間顯示正規化
        </summary>*/
    dateFormatParse(data) {
      var parsedate = data.split("T");
      var date = parsedate[0].replace(/-/gi, "/");
      var slittime = parsedate[1].substr(0, 2);
      var afterorbeforenoon = slittime;
      if (parseInt(afterorbeforenoon) > 12) {
        afterorbeforenoon = "下午";
      } else {
        afterorbeforenoon = "上午";
      }
      this.mergetime = date + " " + afterorbeforenoon + " " + parsedate[1];
    },
    /*       <summary>
        時間顯示正規化
        </summary>*/
    timeFormatParse(data) {
      var parsedate = data.split("T");
      var date = parsedate[0].replace(/-/gi, "/");
      var slittime = parsedate[1].substr(0, 2);
      var afterorbeforenoon = slittime;
      if (parseInt(afterorbeforenoon) > 12) {
        afterorbeforenoon = "下午";
      } else {
        afterorbeforenoon = "上午";
      }
      var time = date + " " + afterorbeforenoon + " " + parsedate[1];
      return time;
    },
    /*       <summary>
        關閉視窗
        </summary>*/
    closeWindow() {
      this.gisobject.closeWindow();
    },
    closeCropWindow() {
      this.gisobject.closeCropWindow();
    },
    closeChartWindow(){
      this.gisobject.closeChartWindow();
    },
    closeSectWindow(){
      this.gisobject.closeSectWindow();
    },
    closeSectSubWindow(){
      this.gisobject.closeSectSubWindow();
    },
    closePDWindow() {
      this.gisobject.closePDWindow();
    },

    closeall() {
      // this.gisobject.closeWindow();
      // this.gisobject.closeChartWindow();
      // this.gisobject.closePDWindow();
      this.gisobject.informationshow = false;
    },
    /*       <summary>
        更改"警戒"與"注意"的標題
        </summary>*/
    changeTitle(disaster) {
      switch (disaster) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          this.title = "警戒";
          break;
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          this.title = "注意";
          break;
      }
    },
    /*       <summary>
        告警門檻
        </summary>*/
    changeCodition(data) {
      switch (data.Note) {
        case 1:
          this.message = "陸上颱風警報";
          break;
        case 2:
          this.message =
            "相對濕度比前一小時減少10%以上，溫度增加一度以上，且溫度>34℃，相對濕度<54%";
          break;
        case 3:
          this.message =
            "過去" +
            data.DURATION +
            "小時，累積雨量高於" +
            data.THRESHOLD +
            "mm";
          break;
        case 4:
          this.message =
            "過去" +
            data.DURATION +
            "小時，平均溫度高於" +
            data.THRESHOLD +
            "℃";
          break;
        case 5:
          this.message =
            "過去" +
            data.DURATION +
            "小時，平均溫度低於" +
            data.THRESHOLD +
            "℃";
          break;
        case 6:
          this.message = "未來7天，有可能持續降雨";
          break;
        case 7:
          this.message = "未來7天，預測溫度高於" + data.THRESHOLD + "℃";
          break;
        case 8:
          this.message = "未來7天，預測溫度低於" + data.THRESHOLD + "℃";
          break;
        case 9:
          this.message = "未來7天，預測日升溫高於" + data.THRESHOLD + "℃";
          break;
        case 10:
          this.message = "未來7天，預測日降溫低於" + data.THRESHOLD + "℃";
          break;
      }
    },
    /*       <summary>
        取得農作物在該城市的範圍
        </summary>*/
    getCityArea() {
      this.gisobject.regetCityArea(this.yearSelected, this.periodSelected);
    },
    checkMomth(Note) {
      if(Note == 3){
        var d = new Date();
        var nowMonth = d.getMonth() + 1;
        if (nowMonth == 5 || nowMonth == 6) {
          this.disasterTile[3] = "梅雨警戒";
        }
        else{
          this.disasterTile[3] = "霪雨警戒";
        }
      }
      return this.disasterTile[Note];
      
    },
    
  },
};
</script>

<style scoped>
.gis-info {
  height: auto;
  display: inline-block !important;
}
.pointer:hover {
  cursor: pointer;
}
.gis-basic .gis-info {
  overflow-y: auto;
  overflow-x: hidden;
}
.p-3 {
  position: relative;
}
.title {
  background-color: #4f8321;
  color: white;
}
.text-green {
  color: #4f8321;
}
.informationBoxClass {
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: #eee;
  max-width: 550px;
  max-height: 80vh;
  overflow-y: auto;
  z-index: 1005;
  background-color: rgba(108, 117, 125, 0.8);
  border-radius: 5px;
}
.informationBoxTitle {
  background: linear-gradient(to right, #6baf1d 0%, #4c7f1f 100%);
  color: #fff;
  border-radius: 5px 5px 0 0;
}

.informationBoxContent {
  padding-top: 1em;
}

.informationBoxTitle h3 {
  padding: 0.5em 0 0.2em 0;
}

@media screen and (max-width: 1024px) {
  .informationBoxClass {
    width: 95vw;
  }
}
</style>
